export { default } from './BackgroundIcon';
